import { render, staticRenderFns } from "./chanpin.vue?vue&type=template&id=60a8f994"
import script from "./chanpin.vue?vue&type=script&lang=js"
export * from "./chanpin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports